import { RootState } from '../../store/reducers';
import { HelpFAQDto } from './help.dto';

export const selectFaqData = (state: RootState): HelpFAQDto[] => state.faq;
